import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Courses from "@/pages/courses/page";
import Cases from "@/pages/cases/page";
import Treatments from "@/pages/treatments/page";
import Articles from "@/pages/articles/page";
import Faq from "@/pages/faq/page";
import Team from "@/pages/team/page";
import Franchise from "@/pages/franchise/page";
import Auth from "@/pages/auth/page";
import Member from "@/pages/member/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/treatments",
    element: <Treatments />,
  },
  {
    path: "/courses",
    element: <Courses />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/articles",
    element: <Articles />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/team",
    element: <Team />,
  },
  {
    path: "/franchise",
    element: <Franchise />,
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/member",
    element: <Member />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;